/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const dataDogInit = () => {
  const isProd = window.location.hostname === 'lupini.allarahealth.com'

  if (isProd) {
    try {
      import('@datadog/browser-rum').then(({ datadogRum }) => {
        datadogRum.init({
          applicationId: 'beb4cf48-a506-485c-a853-3c5d417cddfa',
          clientToken: 'pub79715117050efd05378f9f9e97cd0a29',
          site: 'datadoghq.com',
          service: 'admin-ui',
          env: 'prod',
          version: '1.0.0',
          sessionSampleRate: 100,
          sessionReplaySampleRate: 100,
          defaultPrivacyLevel: 'mask-user-input',
          trackResources: true,
          trackLongTasks: true,
          trackUserInteractions: true,
        })
      })

      import('@datadog/browser-logs').then(({ datadogLogs }) => {
        datadogLogs.init({
          clientToken: 'pub79715117050efd05378f9f9e97cd0a29',
          site: 'datadoghq.com',
          service: 'admin-ui',
          forwardErrorsToLogs: true,
          sessionSampleRate: 100,
          env: 'prod',
        })
      })
    } catch (err) {
      const error = err as Error
      // eslint-disable-next-line no-console
      console.log(`Error to initialize datadog: ${error.message}`)
    }
  }
}
